import { useMemo } from "react";
import { NavLink } from "react-router";
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
  Icon,
} from "@elaniintc/goes-design-system";

import { useAuthorization } from "@/hooks/use-authorization";
import { Permissions } from "@/utils/permissions";

const Menu = ({
  entity,
  id,
  groups,
  groupsImLeaderOf = [],
  onUpdateAssignee,
}: {
  entity: string;
  id: string;
  groups: { id: string }[];
  onUpdateAssignee: (groupsImLeaderOf: string[]) => void;
  groupsImLeaderOf: string[];
}) => {
  const { hasPermission } = useAuthorization();
  const canReadRequests = hasPermission(Permissions.formality_requests.read);
  const canUpdateAssignee = hasPermission(
    Permissions.formality_requests.assign,
  );

  const groupsProcessImLeaderOf = useMemo(() => {
    return groups
      .filter((group) => groupsImLeaderOf.includes(group.id))
      .map((g) => g.id);
  }, [groups, groupsImLeaderOf]);

  if (!canReadRequests && !canUpdateAssignee) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="xs" className="size-8">
          <Icon
            type="far"
            name="ellipsis-vertical"
            className="text-current text-sm"
          />
          <span className="sr-only">
            Acciones para {entity} {id}
          </span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className="w-55.5 min-w-56 rounded-lg border-neutral-silent text-body font-normal"
        side="bottom"
        align="end"
        sideOffset={4}
      >
        <DropdownMenuGroup>
          {canReadRequests && (
            <DropdownMenuItem
              className="hover:bg-neutral-object-accent-silent py-2 px-3 cursor-pointer"
              asChild
            >
              <NavLink to={`/tramite/${id}`} className="w-full h-full block">
                Detalle
              </NavLink>
            </DropdownMenuItem>
          )}
          {canUpdateAssignee && groupsProcessImLeaderOf.length > 0 && (
            <DropdownMenuItem
              className="hover:bg-neutral-object-accent-silent py-2 px-3 cursor-pointer"
              onClick={() => onUpdateAssignee(groupsProcessImLeaderOf)}
            >
              Reasignar solicitud
            </DropdownMenuItem>
          )}
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default Menu;
